import React from 'react';

import CustomTd from '../shared/table/CustomTd';
import EditDeleteButton from '../shared/buttons/EditDeleteButton';
import formatter from '../../utilities/formatter';
import postData from '../../utilities/postData';
import PropTypes from 'prop-types';
import useBreakpoints from '../../utilities/useBreakpoints';

const ServiceCallItem = (props) => {
    const { item } = props;

    const deleteUrl = '/api/servicecalls/delete/' + item.id;

    const { isBreakpoint } = useBreakpoints();

    function deleteItem() {
        postData(deleteUrl, null, () => {
            props.fetchData();
            window.dispatchEvent(new Event('updateChangeLog'));
        });
    }

    return (
        <React.Fragment>
            <tr>
                <CustomTd hide="sm" content={formatter.date(item.dateCalledIn)} />
                <CustomTd style={{textWrap:'balance'}} content={formatter.dateTimePretty(item.jobAppointmentStartTime)} />
                <CustomTd
                    hide="sm"
                    className="text-pre-wrap"
                    content={item.description}
                />
                <CustomTd className="button-cell">
                    <EditDeleteButton
                        deleteItem={deleteItem}
                        viewItem={props.editItem}
                        editItem={props.editItem}
                        showText={false}
                        acl={item.acl}
                    />
                </CustomTd>
            </tr>
            {!isBreakpoint('sm') &&
                <tr>
                    <CustomTd
                        className="text-pre-wrap border-0"
                        colSpan={2}
                        content={item.description}
                    />
                </tr>
            }
        </React.Fragment>
    );
}

ServiceCallItem.propTypes = {
    deleteUrl: PropTypes.string,
    editItem: PropTypes.func,
    fetchData: PropTypes.func
};

export default ServiceCallItem;